var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-icon',{attrs:{"name":_vm.itemStatus.icon,"aria-label":_vm.humanStatus,"size":12,"variant":_vm.itemStatus.variant}})
}
var staticRenderFns = []

export { render, staticRenderFns }